// extracted by mini-css-extract-plugin
export default {"button-text":"button-text--J74yu"};